import store from '@/store';

/** 广告版位-表单配置 */
export {
  delivery_range,
};

const delivery_range = {
  value: {},
  children: {
    inventory_catalog: {
      label: '广告位大类',
      type: 'radio-group',
      isButton: true,
      options: [
        {
          label: '首选媒体',
          value: 'MANUAL',
        },
      ],
      formItemProps: {
        required: true,
      },
      value: 'MANUAL',
      hidden: false,
    },
    /** inventory_catalog = MANUAL 有效且必填 */
    inventory_type: {
      label: '广告投放位置',
      type: 'select',
      options: store.getters.jrttEnum.ad_inventory_type,
      value: [],
      props: {
        multiple: true,
        disabled: false,
      },
      rules: [{ required: true, message: '请选择广告投放位置', trigger: 'change' }],
      hidden: false,
    },
    /**
     * 当的广告投放位置只有穿山甲的时候会显示）
     * @description inventory_catalog = MANUAL && inventory_type 仅有 INVENTORY_UNION_SLOT 时 有效且必填
     */
    union_video_type: {
      label: '投放形式',
      type: 'select',
      hidden: true,
      options: [
        {
          label: '原生视频',
          value: 'ORIGINAL_VIDEO',
        },
        {
          label: '激励视频',
          value: 'REWARDED_VIDEO',
        },
        {
          label: '开屏视频',
          value: 'SPLASH_VIDEO',
        },
      ],
      props: {
        disabled: false,
      },
      rules: [{ required: true, message: '请选择投放形式', trigger: 'change' }],
      value: [],
    },
  },
};
